module.exports = __webpack_public_path__ + "static/media/ImageUpload.03be2a86.png";